import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';
import { MessageService } from './message.service';
import { DimHttpServerResponse } from '@servicesv2';
import { ReducoesICMSInterestaduaisViewModel } from '@produto';

@Injectable()
export class ReducoesICMSInterestaduaisService extends BaseService {

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  obterPorItemId(id: number) {
    return this.http.get(this.UrlService + `reducoesICMSInterestaduais/${id}`)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  obterPorItemIdEstadual(id: number, estadoId: number) {
    return this.http.get(this.UrlService + `reducoesICMSInterestaduais/${id}/${estadoId}`)
      .pipe(map((res: any) => res.data as ReducoesICMSInterestaduaisViewModel), catchError(super.serviceError));
  }

  obterPorItemIdEstadualItens(obj: any) {
    return this.http.post(this.UrlService + 'reducoesICMSInterestaduais/obterReducoesItens', obj)
      .pipe(map((res: any) => res.data as ReducoesICMSInterestaduaisViewModel[]),
        catchError(super.serviceError));
  }

  addOrUpdate(obj: any) {
    return this.http
      .post(this.UrlService + 'reducoesICMSInterestaduais', obj)
      .pipe(map(super.extractData)
        , catchError(super.serviceError));
  }
}